import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Inter';
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Inter';
`;

export const ModalBody = styled.div`
  margin-bottom: 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HorizontalInputWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: end;
`;

export const FlexInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const FileTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100px;
  max-width: 120px;
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
`;

export const StyledInput = styled.input`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter';
  
  &:focus {
    outline: none;
    border-color: #007bff;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const StyledSelect = styled.select`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter';
  background-color: white;
  
  &:focus {
    outline: none;
    border-color: #007bff;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const StepIndicator = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 2px solid #e0e0e0;
`;

export const TreeContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 12px;
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
`;

export const SelectedCount = styled.div`
  font-size: 13px;
  color: #007bff;
  font-weight: 600;
  padding: 8px 12px;
  background: #e7f3ff;
  border-radius: 4px;
  text-align: center;
`;

export const Step2ContentWrapper = styled.div`
  position: relative;
`;

export const LoadingBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 4px;
  z-index: 1;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;